import { useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from 'tss-react/mui';
import { ODPLogoDark, ODPSmallLogo, ODPTextLogo } from '@mb.io/core-components';
import Box from '@mui/material/Box';

const useStyles = makeStyles<{ shouldDisplayLarger: boolean }>()(_ => ({
  svg: {
    width: 140,
    height: 47,
    transition: 'all ease-in 0.4s',
  },
  svgSmall: {
    width: '100%',
    height: '100%',
    transition: 'all ease-in 0.4s',
    display: 'block',
  },
}));

export const ApplicationLogo = () => {
  const { isOpen } = useSidebarOpenState();
  const { classes } = useStyles({ shouldDisplayLarger: isOpen });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center',
      }}
    >
      {isOpen && (
        <>
          <ODPLogoDark className={classes.svg} />
          <ODPTextLogo />{' '}
        </>
      )}
      {!isOpen && (
        <Box
          sx={{
            width: 32,
            height: 32,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <ODPSmallLogo className={classes.svgSmall} />
        </Box>
      )}
    </Box>
  );
};
